$(document).on("click", ".js-wk_del_pos_soft", function(e){
    e.preventDefault();
    var $currentElement = $(this);
    var tmpText = $currentElement.text();
    $currentElement.removeClass("js-wk_del_pos_soft").addClass("js-wk_del_pos google_event_btn wk_produkt_liste_del-active").find(".js-wk_del_pos_text").text($currentElement.data("confirm"))
    setTimeout(function(){
        $currentElement.removeClass("js-wk_del_pos google_event_btn wk_produkt_liste_del-active").addClass("js-wk_del_pos_soft").find(".js-wk_del_pos_text").text(tmpText)

    }, 8000)
});

$(document).on("click", ".js-wk_del_pos", function(e){
    e.preventDefault();
    var $currentElement = $(this);

    $.ajax({
        url:$currentElement.data("root") + "cmshx_template/ajax/wk_remove_pos.php",
        data:{id:$currentElement.data("id"),
              csrf_token:csrf_token
        },
        type:"POST"
    }).done(function(success){
        if(success == 1){
            document.location.reload();
        }
    })
});

$(document).on("click keydown", ".js-wk_del_soft", function(e){
    if(e.key !== "Enter" && e.key!== " " && e.type !== "click") return;
    e.preventDefault();
    var $currentElement = $(this);
    var tmpText = $currentElement.text();
    $currentElement.removeClass("js-wk_del_soft").addClass("js-wk_del wk_button-del-active").find(".js-wk_del_text").text($currentElement.data("confirm"))
    setTimeout(function(){
        $currentElement.removeClass("js-wk_del wk_button-del-active").addClass("js-wk_del_soft").find(".js-wk_del_text").text(tmpText)
    }, 8000)
});

$(document).on("click keydown", ".js-wk_del", function(e){
    if(e.key !== "Enter" && e.key!== " " && e.type !== "click") return;
    e.preventDefault();
    var $currentElement = $(this);

    $.ajax({
        url:$currentElement.data("root") + "cmshx_template/ajax/wk_del.php",
        type:"POST",
        data:{csrf_token:csrf_token}
    }).done(function(success){
        if(success == 1){
            document.location.reload();
        }
    })
});

$(document).on("click", ".js-wk_refresh", function(e){
    e.preventDefault();
    var $currentElement = $(this);
    var addGet = "";
    if($currentElement.data("id") != "") addGet += "?id=" + $currentElement.data("id");
    showLoader();
    $.ajax({
        url:$currentElement.data("root") + "cmshx_template/ajax/wk_refresh.php" + addGet,
        type:"POST",
        data:$(".js-wk_form").serialize(),
        dataType: "json",
    }).done(function(response){
        if(response.valid == 0){
            $.each(response.error, function(key, value){
                $(".js-produkt_liste_error-" + key).text(value);
            })
        }else{
            if(response.change)document.location = document.location;
        }
        hideLoader();
    })
});

$(document).on("click", ".js-wk_add_rabattcode", function(e){
    e.preventDefault();
    var $currentElement = $(this);

    formMsgBlockHide();

    if($("[name=\"rabattcode\"]").val() != ""){
        showLoader();
        $.ajax({
            url:$currentElement.data("root") + "cmshx_template/ajax/wk_add_rabattcode.php",
            type:"POST",
            data:$(".js-wk_form").serialize(),
            dataType: "json",
        }).done(function(response){
            if(response.valid == 0){
                formMsgBlockSetText($(".js-wk_rabattcode_error"), response.error);
                formMsgBlockShow($(".js-wk_rabattcode_error"));
            }else{
                formMsgBlockSetText($(".js-wk_rabattcode_success"), response.success);
                formMsgBlockShow($(".js-wk_rabattcode_success"));
                setTimeout(function(){
                    document.location = document.location;
                }, 1000)
            }
            hideLoader();
        })
    }
});

$(document).on("click", ".js-wk_del_soft_teilnehmer", function(e){
    e.preventDefault();
    var $currentElement = $(this);
    var tmpText = $currentElement.text();
    $currentElement.removeClass("js-wk_del_soft_teilnehmer").addClass("js-wk_del_teilnehmer wk_produkt_liste_teilnehmer_del-active")
    setTimeout(function(){
        $currentElement.removeClass("js-wk_del_teilnehmer wk_produkt_liste_teilnehmer_del-active").addClass("js-wk_del_soft_teilnehmer")
    }, 8000)
});

$(document).on("click", ".js-wk_del_teilnehmer", function(e){
    e.preventDefault();
    var $currentElement = $(this);
    showLoader();
    $.ajax({
        url:$currentElement.data("root") + "cmshx_template/ajax/wk_remove_teilnehmer.php",
        type:"POST",
        data:{pos:$currentElement.data("pos"),
              teil:$currentElement.data("teil"),
              csrf_token:csrf_token
        },
        dataType: "json",
    }).done(function(response){
        if(response.valid == 0){
            $(".js-produkt_liste_error-" + $currentElement.data("pos")).text(response.error);
        }else{
            document.location = $currentElement.attr("href");
        }
        hideLoader();
    })
});

